<mat-nav-list style="overflow: hidden;">
    <a [href]="this.authService.getRegistredUserDetails().officialWebsite" target="_blank">
        <img [src]="createImgPath(imageServerPath)" (error)="onImgError($event)" alt="Logo" class="login-logo" /></a>
    <!-- {{this.authService.getRegistredUserDetails().officialWebsite}} -->
        <mat-accordion>
        <mat-nav-list>
            <div class="nav-item active">
                <a class="nav-link" mat-list-item (click)="closeVendorsPanel()" routerLink="/All/dashboardCompo"
                    routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
                    <mat-icon class="nav-icon">home</mat-icon>
                    Dashboard
                </a>
            </div>

            <div class="nav-item">
                <mat-expansion-panel #vendorsPanel [class.mat-elevation-z0]="true">
                    <mat-expansion-panel-header routerLinkActive="active-list-item">
                        <mat-icon class="nav-icon">persons</mat-icon> Business Profile
                    </mat-expansion-panel-header>
                    <mat-nav-list>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/All/updateBank" routerLinkActive="active-list-item">
                                <li>Bank Details</li>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/All/updateCompany" routerLinkActive="active-list-item">
                                <li>Company Details</li>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/All/publicDetails" routerLinkActive="active-list-item">
                                <li>Public Details</li>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/All/productSetting" routerLinkActive="active-list-item">
                                <li>Product Settings</li>
                            </a>
                        </div>
                    </mat-nav-list>
                </mat-expansion-panel>
            </div>

            <div class="nav-item">
                <mat-expansion-panel #vendorsPanel1 [class.mat-elevation-z0]="true" (opened)="panelOpenState = true"
                    (closed)="panelOpenState = false">
                    <mat-expansion-panel-header routerLinkActive="active-list-item">
                        <mat-icon class="nav-icon">payments</mat-icon>Payments
                    </mat-expansion-panel-header>
                    <mat-nav-list>
                        <div class="nav-item">
                            <a mat-list-item routerLink="/All/payment" routerLinkActive="active-list-item">
                                <li>Payment Links</li>
                            </a>
                        </div>

                        <div class="nav-item">
                            <a mat-list-item routerLink="/All/paymentTransaction" routerLinkActive="active-list-item">
                                <li>Payment Transactions</li>
                            </a>
                        </div>
                    </mat-nav-list>
                </mat-expansion-panel>
            </div>

            <!-- <div class="nav-item">
                <a class="nav-link" mat-list-item (click)="closeVendorsPanel()" routerLink="/All/vendors" routerLinkActive="active-list-item">
                    <span class="material-icons" style="margin-right:10%">
                        people_alt
                    </span>
                    Vendors
                </a>
            </div> -->

            <div class="nav-item">
                <a class="nav-link" mat-list-item (click)="closeVendorsPanel()" routerLink="/All/vendors"
                    routerLinkActive="active-list-item">
                    <span class="material-icons" style="margin-right:10%">
                        people_alt
                    </span>
                    Vendors
                </a>
            </div>

            <div class="nav-item">
                <a class="nav-link" mat-list-item (click)="closeVendorsPanel()" routerLink="/All/refunds"
                    routerLinkActive="active-list-item">
                    <span class="material-icons" style="margin-right:10%">
                        monetization_on
                    </span>
                    Refunds
                </a>
            </div>
        </mat-nav-list>
    </mat-accordion>
</mat-nav-list>